import * as R from 'ramda'
import Big from 'big.js'
import uuidv4 from '@/utilities/uuid.js'
import api from '@/api'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'

const seedItemPresenter = (seedItem, itemId) => {
  return {
    id: itemId,
    description: seedItem['description'],
    costPerUnit: seedItem['costPerUnit'],
    seedsPerUnit: seedItem['seedsPerUnit'],
    costPerSeed: new Big(seedItem['costPerUnit']).div(seedItem['seedsPerUnit']).toFixed(4),
    defaultSeedingRate: seedItem['defaultSeedingRate']
  }
}

const state = {
  seedItems: {}
}

const mutations = {
  LOAD_SEED_ITEMS (state, payload) {
    state.seedItems = payload
  },

  UPDATE_SEED_ITEM (state, { id, item }) {
    state.seedItems[id] = item
  },

  ADD_SEED_ITEM (state, { id, item }) {
    const items = {
      ...state.seedItems,
      [id]: item
    }

    state.seedItems = items
  },

  DELETE_SEED_ITEM (state, payload) {
    state.seedItems = R.omit(payload, state.seedItems)
  }
}

const actions = {
  updateSeedItem ({ commit, getters }, jsConn) {
    if (jsConn.formParams.id === 'new') {
      const id = uuidv4()

      jsConn.formParams = {
        id: id,
        item: jsConn.formParams.item
      }

      if (getters.signedIn) {
        return api.createSeed(jsConn)
          .then(jsConn => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
            commit('ADD_SEED_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.formParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully saved'
        commit('ADD_SEED_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    } else {
      if (getters.signedIn) {
        return api.updateSeed(jsConn)
          .then((jsConn) => {
            return successPipeline(jsConn)
          })
          .then(jsConn => {
            jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
            commit('UPDATE_SEED_ITEM', jsConn.formParams)
            return Promise.resolve(jsConn)
          })
          .catch(jsConn => {
            jsConn.toastMessage = 'Unable to save ' + jsConn.apiParams['item']['description']
            return Promise.reject(jsConn)
          })
      } else {
        jsConn.toastMessage = jsConn.formParams['item']['description'] + ' successfully updated'
        commit('UPDATE_SEED_ITEM', jsConn.formParams)
        return Promise.resolve(jsConn)
      }
    }
  },

  deleteSeedItem ({ commit, getters, dispatch }, jsConn) {
    if (getters.signedIn) {
      return api.deleteSeed(jsConn)
        .then((jsConn) => {
          return successPipeline(jsConn)
        })
        .then(jsConn => {
          dispatch('deleteSeedItemFromAllCrops', jsConn)
          commit('DELETE_SEED_ITEM', [jsConn.formParams['id']])
          jsConn.toastMessage = 'Seed item deleted'
          return Promise.resolve(jsConn)
        })
        .catch(jsConn => {
          jsConn.toastMessage = 'Unable to delete item'
          return Promise.reject(jsConn)
        })
    } else {
      dispatch('deleteSeedItemFromAllCrops', jsConn)
      commit('DELETE_SEED_ITEM', [jsConn.formParams['id']])
      jsConn.toastMessage = 'Item deleted for this browser session'
      return Promise.resolve(jsConn)
    }
  }
}

const getters = {
  seedItems: state => state.seedItems,

  seedItemsIdList: state => {
    return Object.keys(state.seedItems)
  },

  seedItemsList: (state, getters, rootState, rootGetters) => {
    const itemsList = R.map((itemId) => {
      const item = getters.getSeedItemById(itemId)
      return seedItemPresenter(item, itemId)
    }, getters.seedItemsIdList)

    return itemsList
  },

  getSeedItemById: (state) => (id) => {
    return state.seedItems[id]
  }
}

const seedModule = {
  state,
  mutations,
  actions,
  getters
}

export default seedModule
